import { Box, styled } from '@mui/material';
import IconCaretLeft from 'assets/img/icons/caret-left.svg?react';
import IconCaretRight from 'assets/img/icons/caret-right.svg?react';
import { LwButton, LwIconButton } from 'redesign';
import { ReactNode } from 'react';

type Props = {
  label: string | null;
  centerLabel?: ReactNode;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  todayPosition?: 'left' | 'right';
};

export const DateControlBase = ({
  label,
  centerLabel,
  onPrev,
  onNext,
  onToday,
  todayPosition,
}: Props) => {
  return (
    <StyledContainer todayPosition={todayPosition || 'left'}>
      <StyledDateControlBox>
        <Box display="flex" flexDirection="row" alignItems="center">
          <LwIconButton sx={iconButtonSx} iconColorMode="stroke" onClick={onPrev} color="secondary">
            <StyledSvgIcon as={IconCaretLeft} />
          </LwIconButton>

          {centerLabel && <StyledInfoBox>{centerLabel}</StyledInfoBox>}

          <LwIconButton sx={iconButtonSx} iconColorMode="stroke" onClick={onNext} color="secondary">
            <StyledSvgIcon as={IconCaretRight} />
          </LwIconButton>
        </Box>

        {label ? <StyledLabelBox>{label}</StyledLabelBox> : null}
      </StyledDateControlBox>
      <LwButton onClick={onToday} color="secondary">
        Vandaag
      </LwButton>
    </StyledContainer>
  );
};

const iconButtonSx = {
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #001a9933',
  borderRadius: '50%',
  padding: '1rem',
};

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'todayPosition',
})<{ todayPosition: 'left' | 'right' }>(({ theme, todayPosition }) => ({
  display: 'flex',
  flexDirection: todayPosition === 'right' ? 'row' : 'row-reverse',
  alignItems: 'center',
  gap: theme.spacing(8),
}));

const StyledSvgIcon = styled('svg')(({ theme }) => ({
  height: theme.spacing(4),
  width: theme.spacing(4),
}));

const StyledDateControlBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  margin: 'auto',
  alignItems: 'center',
  gap: theme.spacing(8),
}));

const StyledLabelBox = styled(Box)(() => ({
  width: '230px',
  display: 'flex',
  alignItems: 'center',
}));

const StyledInfoBox = styled(Box)(({ theme }) => ({
  margin: '0 1rem',
  color: theme.palette.lwPrimaryAccentDark['100'],
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: 'normal',
  width: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
